import {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import styled from "styled-components";
import {IoClose, IoMenuOutline} from "react-icons/io5";
import logo from "../assets/images/logo.png";

const HeaderContainer = styled.div`
    background-color: transparent;
    box-shadow: 0 0.4px 3px rgb(0, 195, 255);
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1000;
    background: rgb(31, 1, 16);
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
`;

const Box = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const LogoImage = styled.img`
    height: 55px;
`;

const HeaderUl = styled.ul`
    display: flex;
    list-style: none;
    margin: 0;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
        display: none;
    }
`;

const NavItem = styled.li`
    position: relative;
    font-size: 16px;
    display: inline-block;

    a {
        text-decoration: none;
        color: ${(props) => (props.isActive ? "#4caf50" : "rgb(0, 195, 255)")};
        font-weight: ${(props) => (props.isActive ? "900" : "800")};
        padding: 14px 12px;
        border-radius: 5px;
        border-bottom: ${(props) => (props.isActive ? "2px solid #4caf50" : "#333")};
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-2px);
            color: #ccc;
            background-color: rgb(0, 195, 255, 0.2);
            border-radius: 5px;
        }
    }

    &:hover > div {
        display: block;
        opacity: 1;
        transform: translateY(0);
    }
`;

const NavIcon = styled.div`
    @media (min-width: 769px) {
        display: none;
    }

    svg {
        font-size: 35px;
        color: rgb(0, 195, 255);
        cursor: pointer;
        margin: 0 10px;
    }
`;

const SideNav = styled.div`
    background: rgb(31, 1, 16);

    position: fixed;
    top: 0;
    left: ${({show}) => (show ? "0" : "-100%")};
    width: 85%;
    height: 100vh;
    // background-color: #333;
    color: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    transition: left 0.3s ease;
    z-index: 999;
`;

const SideNavItem = styled(Link)`
    color: ${(props) => (props.isActive ? "#4caf50" : "rgb(0, 195, 255)")};
    font-weight: ${(props) => (props.isActive ? "700" : "500")};
    border-bottom: ${(props) => (props.isActive ? "1px solid #4caf50" : "#333")};
    text-decoration: none;
    font-size: 15px;
    padding: 8px 10px;
    border-radius: 5px;
    transition: all 0.3s ease;

    &:hover {
        background-color: #4caf50;
        color: white;
    }
`;

const Header = () => {
    const location = useLocation();
    const [activeNav, setActiveNav] = useState(location.pathname);
    const [showNav, setShowNav] = useState(false);

    useEffect(() => {
        setActiveNav(location.pathname);
    }, [location]);

    const toggleNav = () => {
        setShowNav(!showNav);
    };

    return (
        <HeaderContainer>
            <Box>
                <Link to="/">
                    <LogoImage src={logo} loading="lazy" alt="Logo" />
                </Link>

                <HeaderUl>
                    {["/", "/About", "/Contact", "/Artists", "/Apply Now"].map((path, index) => (
                        <NavItem key={index} isActive={activeNav === path}>
                            <Link to={path}>{path === "/" ? "Home" : path.slice(1)}</Link>
                        </NavItem>
                    ))}
                </HeaderUl>

                <NavIcon onClick={toggleNav}>{showNav ? <IoClose /> : <IoMenuOutline />}</NavIcon>
            </Box>

            <SideNav show={showNav}>
                <Link to="/">
                    <LogoImage src={logo} loading="lazy" alt="Logo" />
                </Link>
                {["/", "/About", "/Contact", "/Artists", "/Apply Now"].map((path, index) => (
                    <SideNavItem key={index} to={path} isActive={activeNav === path} onClick={() => setShowNav(false)}>
                        {path === "/" ? "Home" : path.slice(1)}
                    </SideNavItem>
                ))}
            </SideNav>
        </HeaderContainer>
    );
};

export default Header;
